<template>
  <div>
    <VOverlayIntro :loadingIntro="loadingIntro" />
    <main-header-plat-a-pat />
    <v-row class="d-flex flex-wrap flex-sm-nowrap">
      <v-col xs="12" sm="6" md="5" class="pl-0 ml-0">
        <v-container class="mt-2">
          <v-card>
            <v-row class="fill-height">
              <v-col>
                <v-sheet height="64">
                  <v-toolbar flat>
                    <v-row>
                      <v-col cols="12" class="py-0">
                        <v-toolbar-title v-if="$refs.calendar">
                          {{ $refs.calendar.title }}
                        </v-toolbar-title>
                      </v-col>
                      <v-col cols="9" class="py-0">
                        <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
                          Hoy
                        </v-btn>
                        <v-btn fab text small color="grey darken-2" @click="prev">
                          <v-icon small> mdi-chevron-left </v-icon>
                        </v-btn>
                        <v-btn fab text small color="grey darken-2" @click="next">
                          <v-icon small> mdi-chevron-right </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-toolbar>
                </v-sheet>
                <v-sheet height="1200">
                  <v-calendar
                    ref="calendar"
                    v-model="focus"
                    color="primary"
                    :events="calendarEvents"
                    :event-color="getEventColor"
                    :type="type"
                    @click:event="showEvent"
                    @click:more="viewDay"
                    @click:date="viewDay"
                    @change="updateRange"
                    first-time="04:00"
                    :interval-count="20"
                  ></v-calendar>

                  <v-menu
                    v-model="selectedOpen"
                    :close-on-content-click="false"
                    :activator="selectedElement"
                    offset-x
                    min-width="550px"
                  >
                    <v-card color="grey lighten-4" width="550px" flat>
                      <v-toolbar :color="selectedEvent.color" dark>
                        <span class="text-h6 ml-2">{{ selectedEvent.name }}</span>
                      </v-toolbar>

                      <v-card-text>
                        <v-form v-if="currentlyEditing !== selectedEvent.id" class="ml-4">
                          <p v-if="selectedEvent.name?.includes('Sesión')">
                            <b>Profesional de la Salud Mental:</b>
                            {{ selectedEvent.instProfesName }}
                          </p>
                        </v-form>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </v-sheet>
              </v-col>
            </v-row>
          </v-card>
        </v-container>
      </v-col>
      <v-col xs="12" sm="6" md="7" class="d-flex flex-wrap justify-center align-center">
        <v-col
          cols="8"
          xs="12"
          sm="8"
          md="6"
          class="d-flex justify-center align-center flex-wrap mb-0 pb-0"
        >
          <a
            href="https://www.freepik.es/vector-gratis/ilustracion-concepto-abstracto-servicio-psicologo-sesion-privada-psicologia-servicio-salud-mental-psicologia-familiar-terapia-infantil-psicoterapia-pareja_10780663.htm#fromView=search&page=1&position=1&uuid=cea62916-9ce7-489a-b43d-e2421608273a"
            class="white--text caption"
            v-if="$vuetify.breakpoint.xsOnly"
            >Imagen de vectorjuice en Freepik</a
          >
          <v-img
            src="@/assets/BannerPatHome1.webp"
            class="d-flex justify-center align-center py-8 px-5"
          />
        </v-col>
        <v-col
          cols="8"
          xs="12"
          sm="10"
          md="6"
          class="d-flex text-body-2 text-center justify-center align-center mt-2 pt-2 mb-10 mb-md-0"
        >
          Tener una historia clínica completa nos permite comprender mejor tu situación actual y tus
          necesidades únicas; además, nos ayuda a identificar patrones o factores desencadenantes en
          tu vida que puedan afectar tu salud mental. De esta manera, podemos personalizar tu
          tratamiento y desarrollar estrategias de afrontamiento y prevención más efectivas.
        </v-col>
        <v-col
          cols="8"
          xs="12"
          sm="8"
          md="6"
          class="d-flex text-body-2 text-center justify-center align-center"
          v-if="$vuetify.breakpoint.mdAndUp"
        >
          Tener un registro de nuestras sesiones psicoterapéuticas permite recordar lo que hemos
          conversado en sesiones anteriores, lo que puede ser útil para seguir el progreso de tu
          tratamiento a lo largo del tiempo. Podremos compartir tus pensamientos y observaciones de
          una manera más estructurada, lo que puede enriquecer nuestras conversaciones y facilitar
          un trabajo más profundo y significativo.
        </v-col>
        <v-col
          cols="8"
          xs="12"
          sm="10"
          md="6"
          class="d-flex justify-center align-center flex-wrap mb-0 pb-0"
        >
          <a
            href="https://www.freepik.es/vector-gratis/psicologo-sentado-frente-paciente-trastorno-mental-ilustracion-vector-plano-sesion-psiquiatra-atencion-medica-concepto-servicio-psicologico-banner-diseno-sitio-web-o-pagina-web-inicio_22344008.htm#fromView=search&page=7&position=24&uuid=365b7c01-dfd1-4188-9192-f3c0698ffc7e"
            class="white--text caption"
            v-if="$vuetify.breakpoint.xsOnly"
            >Imagen de vectorjuice en Freepik</a
          >
          <v-img src="@/assets/BannerPatHome2.webp" />
        </v-col>
        <v-col
          cols="8"
          xs="12"
          sm="10"
          md="6"
          class="d-flex text-body-2 text-center justify-center align-center mt-0 pt-0 mb-10 mb-md-0"
          v-if="$vuetify.breakpoint.smAndDown"
        >
          Tener un registro de nuestras sesiones psicoterapéuticas permite recordar lo que hemos
          conversado en sesiones anteriores, lo que puede ser útil para seguir el progreso de tu
          tratamiento a lo largo del tiempo. Podremos compartir tus pensamientos y observaciones de
          una manera más estructurada, lo que puede enriquecer nuestras conversaciones y facilitar
          un trabajo más profundo y significativo.
        </v-col>
        <v-col
          cols="8"
          xs="12"
          sm="8"
          md="6"
          class="d-flex justify-center align-center flex-wrap mb-0 pb-0"
        >
          <a
            href="https://www.freepik.es/vector-gratis/ilustracion-concepto-honestidad_20287888.htm#fromView=search&page=1&position=32&uuid=1a31f7e1-59c0-4c64-9a15-eabc31da220f"
            class="white--text caption"
            v-if="$vuetify.breakpoint.xsOnly"
            >Imagen de vectorjuice en Freepik</a
          >
          <v-img 
            src="@/assets/BannerPatHome3.webp" 
            class="my-md-12" 
          />
        </v-col>
        <v-col
          cols="8"
          xs="12"
          sm="10"
          md="6"
          class="d-flex text-body-2 text-center justify-center align-center mt-0 pt-0 mb-10 mb-md-0"
        >
          Optimizar estos procesos te permitirá obtener mejores resultados, lo que facilitará el
          desarrollo de una mayor comprensión de ti mismo, una expresión más clara y una mejor
          comprensión de los demás. Esto puede mejorar significativamente tus relaciones personales
          y profesionales, proporcionándote una base sólida para abordar los desafíos futuros de
          manera más consciente.
        </v-col>
      </v-col>
    </v-row>
    <v-card-footer
      :footerItems="schema.footerItems"
      :legalItems="schema.legalItems"
      :contactItems="schema.contactItems"
      :socialNetItems="schema.socialNetItems"
    />
    <v-snack-bar :snackbar="snackbar" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VOverlayIntro from '@/components/base/VOverlayIntro.vue';
import MainHeaderPlatAPat from '@/components/includes/MainHeaderPlatAPat.vue';
import VCardFooter from '@/components/base/VCardFooter.vue';
import VSnackBar from '@/components/base/VSnackBar.vue';

export default {
  name: 'PatHomePage',
  components: {
    VOverlayIntro,
    MainHeaderPlatAPat,
    VCardFooter,
    VSnackBar,
  },
  data() {
    return {
      today: new Date().toISOString().substring(0, 10),
      focus: new Date().toISOString().substring(0, 10),
      type: 'day',
      typeToLabel: {
        month: 'Mes',
        week: 'Semana',
        day: 'Dia',
        '4day': '4 Dias',
      },
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
      names: ['Sesión', 'Académico', 'Laboral', 'Viaje', 'Ocupado', 'Libre', 'Feriado'],
      name: null,
      color: '#1976D2',
      nPro: '',
      nameProfes: '',
      start: null,
      end: null,
      dialog: false,
      dialogVerif: false,
      loading: false,
      otp: '',
      text: '',
      currentlyEditing: null,
      show1: true,
      loadingIntro: false,
    };
  },
  async mounted() {
    try {
      await Promise.all([
        this.loadSchema(),
        this.loadEvents(),
        this.getEvents()
      ]);
      this.$refs.calendar?.checkChange();
    } catch (error) {
      console.error(error);
    } finally {
      this.loadingIntro = true;
    }
  },
  computed: {
    ...mapGetters('patHomePage', ['schema']),
    ...mapGetters('patAppointmentsAPage', ['events', 'status', 'catEventType', 'dataNameProfes']),
    ...mapGetters('notifications', ['snackbar']),

    calendarEvents() {
      if (!this.events || !this.catEventType) return [];

      return this.events.map(event => {
        const type = this.catEventType.find(t => t.event_type_id == event.name);
        
        return {
          ...event,
          name: type ? type.event_type : event.name 
        };
      });
    },

    title() {
      const { start, end } = this;
      if (!start || !end) {
        return '';
      }

      const startMonth = this.monthFormatter(start);
      const endMonth = this.monthFormatter(end);
      const suffixMonth = startMonth === endMonth ? '' : endMonth;

      const startYear = start.year;
      const endYear = end.year;
      const suffixYear = startYear === endYear ? '' : endYear;

      const startDay = start.day + this.nth(start.day);
      const endDay = end.day + this.nth(end.day);

      switch (this.type) {
        case 'month':
          return `${startMonth} ${startYear}`;
        case 'week':
        case '4day':
          return `${startMonth} ${startDay} ${startYear} - ${suffixMonth} ${endDay} ${suffixYear}`;
        case 'day':
          return `${startMonth} ${startDay} ${startYear}`;
      }
      return '';
    },
    monthFormatter() {
      return this.$refs.calendar.getFormatter({
        timeZone: 'UTC',
        month: 'long',
      });
    },
  },
  methods: {
    ...mapActions('patHomePage', ['loadSchema']),
    ...mapActions('patAppointmentsAPage', ['loadEvents', 'updateEvents', 'delEvents', 'verifPro']),
    ...mapActions('notifications', ['triggerSnackbar']),

    async onFinish() {
      this.loading = true;

      let model = {};
      if (this.nPro === '' || this.nPro === null) {
        model.nPro = this.selectedEvent.nPro;
      } else {
        model.nPro = this.nPro;
      }
      model.otp = this.otp;

      this.$store.dispatch('patAppointmentsAPage/verifPro', { model }).then(
        () => {
          if (this.status === true) {
            setTimeout(() => {
              this.loading = false;
              this.text = 'PIN de Usuario es correcto';
            }, 500);
            this.otp = '';
            this.text = '';

            if (this.dataNameProfes) {
              if (this.nPro === '' || this.nPro === null) {
                this.selectedEvent.nameProfes = this.dataNameProfes;
              } else {
                this.nameProfes = this.dataNameProfes;
              }
            } else {
              if (this.nPro === '' || this.nPro === null) {
                this.selectedEvent.nameProfes = '';
              } else {
                this.nameProfes = '';
              }
              this.snackbar.visible = false;
              this.snackbar.visible = true;
              this.snackbar.content = this.schema.snackNoPatient;
            }
            this.dialogVerif = false;
          } else if (this.status === false) {
            setTimeout(() => {
              this.loading = false;
              this.text = 'PIN de Usuario es incorrecto';
            }, 500);
          }
        },
        () => {
          setTimeout(() => {
            this.loading = false;
            this.text = 'PIN de Usuario es incorrecto';
            this.nameProfes = '';
          }, 500);
        }
      );
      this.otp = '';
      this.text = ' ';
    },
    async getEvents() {
      this.nameProfes = '';

      await this.loadEvents();
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = 'day';
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = this.today;
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() => requestAnimationFrame(() => (this.selectedOpen = true)));
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    updateRange({ start, end }) {
      const toDatetimeLocal = (date) => {
        const pad = (n) => String(n).padStart(2, '0');
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
      };

      this.start = start instanceof Date && !isNaN(start) ? toDatetimeLocal(start) : '';
      this.end = end instanceof Date && !isNaN(end) ? toDatetimeLocal(end) : '';
    }
  },
};
</script>
